import { useQuery } from 'react-query';
import { QueryKeys } from 'utils/queryKeys';
import { apiProspectsRepository } from 'services/repositories/implementations/ApiProspectsRepository';
import type { AxiosClient } from '../services/api/client.ts';

interface UseProspectsQueryProps {
  offset?: number;
  limit?: number;
  search?: string;
  apiDataClient: AxiosClient;
  enabled?: boolean;
}

export function useProspectsQuery({ offset = 0, limit = 50, search = '', apiDataClient, enabled = true }: UseProspectsQueryProps) {
  return useQuery({
    queryKey: QueryKeys.getProspects(offset, limit, search),
    queryFn: () => apiProspectsRepository.getProspects({ offset, limit, search }, apiDataClient),
    enabled,
  });
}
